import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_WHATSAPP_CTA = defineFcm('psf_promote_or_share_whatsapp_cta')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Channel-aware CTA (WhatsApp, Top-8 relaunch, CHANGE-99290): kill-switch + experiment binding for the "Share on WhatsApp" primary button on the promote_or_share share slide-up. Re-tests both layout designs (variant_1 = cta_with_secondary_copy, variant_2 = cta_only) across all Top-8 countries on the shared already-translated copy, rather than assuming the concluded English result (CHANGE-98145) transfers. Country-scoped, not locale-scoped. The productized plane (psf_promote_or_share_channel_aware_cta) is empty everywhere for the duration of the relaunch — if a country is ever added back there, it is excluded from enrollment here, since it would already see the CTA.',
		template: {
			enabled: false,
			experimentName: 'psf_promote_or_share_whatsapp_cta_top_8',
		},
	});
